import {
  Component,
  ChangeDetectionStrategy,
  ElementRef,
  PLATFORM_ID,
  AfterViewInit,
  DOCUMENT,
  inject,
  viewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { DiseaseProfilesState } from '../../store/reducers/disease-profiles.reducer';

import * as fromStore from '../../store';
import { DiseaseProfileCommunity } from '../../models/disease-profile-community.model';
import { getOrderedBlogs } from '../../../blogs/store';
import { isPlatformBrowser, NgStyle, NgClass, AsyncPipe } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { HeaderComponent } from '../../../core/components/header/header.component';
import { InfographicSliderComponent } from '../../components/infographic-slider/infographic-slider.component';
import { IconComponent } from '@teamfoster/sdk/icon';
import { HrefCardComponent } from '../../../core/components/href-card/href-card.component';
import { CardComponent } from '../../../core/components/card/card.component';
import { HighlightedArticleComponent } from '../../components/highlighted-article/highlighted-article.component';
import { BlogBlockComponent } from '../../../blogs/components/blog-block/blog-block.component';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { ResizePipe } from '@teamfoster/sdk/image';
import { StripHtmlPipe, TruncatePipe, UrlRewritePipe } from '@teamfoster/sdk/text-utility';

@Component({
  selector: 'app-disease-profile',
  templateUrl: './disease-profile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeaderComponent,
    NgStyle,
    RouterLink,
    InfographicSliderComponent,
    NgClass,
    IconComponent,
    HrefCardComponent,
    CardComponent,
    HighlightedArticleComponent,
    BlogBlockComponent,
    FromDictionaryPipe,
    ResizePipe,
    StripHtmlPipe,
    TruncatePipe,
    UrlRewritePipe,
  ],
})
export class DiseaseProfileComponent implements AfterViewInit {
  private store = inject<Store<DiseaseProfilesState>>(Store);
  private document = inject(DOCUMENT);
  private platformId = inject(PLATFORM_ID);
  private route = inject(ActivatedRoute);

  profile$ = this.store.selectSignal(fromStore.getSelectedDiseaseProfile);
  pages$ = this.store.selectSignal(fromStore.getAllDiseaseProfilePages);
  blogs$ = this.store.selectSignal(getOrderedBlogs);

  hasColor = ['facebook', 'youtube', 'email', 'twitter', 'linkedin'];

  readonly elInfo = viewChild<ElementRef>('diseaseInfoEl');

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.route.snapshot.fragment) {
        setTimeout(() => {
          // console.log(this.route.snapshot.fragment);
          this.scrollToInfo();
        }, 400);
      }
    }
  }

  groupClass(item: DiseaseProfileCommunity, bg: boolean) {
    const name = this.hasColor.includes(item.icon) ? item.icon : 'primary';
    return bg ? { [`bg-${name}`]: true } : { [`button--${name}`]: true };
  }

  scrollToInfo() {
    const elInfo = this.elInfo();
    if (elInfo) {
      elInfo.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}
